
export type Region = {
  id: string;
  name: string;
  description: string;
};

export const regions: Region[] = [
  {
    id: 'europe',
    name: 'Europe',
    description: 'Airports across European countries'
  },
  {
    id: 'north-america',
    name: 'North America',
    description: 'Airports in North America'
  },
  {
    id: 'asia',
    name: 'Asia',
    description: 'Airports throughout Asia'
  },
  {
    id: 'oceania',
    name: 'Oceania',
    description: 'Airports in Australia, New Zealand, and Pacific Islands'
  },
  {
    id: 'africa',
    name: 'Africa',
    description: 'Airports across African countries'
  },
  {
    id: 'south-america',
    name: 'South America',
    description: 'Airports in South American countries'
  }
];
